module.exports = __webpack_public_path__ + "static/media/On.f3f6a74b.svg";